import { eSSSection } from './eSSSection';
export const SSSectionOptions = {
  [eSSSection.financial_consideration]: 'Financial Consideration',
  [eSSSection.loan_charges_to_lender]: 'Loan Charges to Lender',
  [eSSSection.gross_transaction_fee]: 'Gross Transaction Fee (@ 3.0%)',
  [eSSSection.escrow_title_charges]: 'Escrow/Title Charges',
  [eSSSection.other_loan_charges]: 'Other Loan Charges',
  [eSSSection.recording_fees_and_transfer_taxes]: 'Recording Fees and Transfer Taxes',
  [eSSSection.commissions_other]: 'Commissions/Other',
  [eSSSection.prorations_adjustments]: 'Prorations/Adjustments',
  [eSSSection.payoffs]: 'Payoffs',
  [eSSSection.subtotals]: 'SubTotals',
  [eSSSection.totals]: 'Totals',
  [eSSSection.balance_buyer]: null,
  [eSSSection.balance_seller]: null,
  [eSSSection.investment_amount]: null,
};
export const SSTypeByLabel = {
  'Financial Consideration': eSSSection.financial_consideration,
  'Loan Charges to Lender': eSSSection.loan_charges_to_lender,
  'Gross Transaction Fee (@ 3.0%)': eSSSection.gross_transaction_fee,
  'Escrow/Title Charges': eSSSection.escrow_title_charges,
  'Recording Fees and Transfer Taxes': eSSSection.recording_fees_and_transfer_taxes,
  'Commissions/Other': eSSSection.commissions_other,
  'Prorations/Adjustments': eSSSection.prorations_adjustments,
  Payoffs: eSSSection.payoffs,
  SubTotals: [eSSSection.subtotals],
  Totals: eSSSection.totals,
};

export const getSSSectionLabel = (section: eSSSection): string | null => {
  return SSSectionOptions[section];
};
